<template>
  <div
    v-if="showSharePresentationBar && !isHideBar"
    class="share-presentation-bar horizontal layout center"
    :class="{'has-color': $store.state.slideActive.textColour == '#313131'}"
  >
    <div class="not-logged horizontal layout center" v-if="!$store.state.currentUser.id">
      <div class="flex">
        To use this presentation, create your free AhaSlides account
        <ShareSlideNote />
      </div>
      <div>
        <button class="btn btn-primary" @click="callAction('login')">
          Log in
        </button>
        <button class="btn btn-light" @click="callAction('signup')">
          Sign up
        </button>
      </div>
    </div>
    <div class="logged horizontal layout center" v-if="$store.state.currentUser.id">
      <div
        class="flex shared__presentation-title"
      >
        Shared presentation "{{ $store.state.presentation.name }}"
        <ShareSlideNote />
      </div>
      <div class="shared__copy-presentation">
        <button class="btn btn-primary" @click="copyPresentationShare()">
          <span v-if="copyStatus == 1">
            <i class="fas fa-copy fa-fw" /> Copy to your account
          </span>
          <span v-if="copyStatus == 2">
            <span class="mr-1 loading-spinner mb--2px" /> Copying...
          </span>
          <span v-if="copyStatus == 3">
            <i class="fas fa-check-circle fa-fw" /> Completed
          </span>
          <span v-if="copyStatus == 4">Go to your presentations</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import util from '@/util'
import config from '@/config'
import mixpanelUtils from '@/utils/mixpanel.utils'
import ShareSlideNote from '@/components-v2/presentation-editor/collaboration/ShareSlideNote.vue'

export default {
  name: 'SharePresentationBar',
  components: {
    ShareSlideNote,
  },
  data() {
    return {
      copyStatus: 1,
      isHideBar: util.getParamValue('is_hide_presentation_bar', window.location.href),
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      sharePresentation: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
    }),
    showSharePresentationBar() {
      return this.sharePresentation && !this.isPresenterWhiteLabel && !this.isHideTextShare
    },
    isHideTextShare() {
      return !!util.getParamValue('hideText', window.location.href)
    },
  },
  methods: {
    callAction(type) {
      const inIframe = window.location !== window.parent.location

      let url
      if (type === 'login') {
        url = this.$router.resolve({
          name: 'Login',
          query: { redirect: window.location.href },
        })
        util.gaTrackEvent(
          'Presentation Share',
          `${inIframe ? 'iFrame > Log In' : 'Window > Log In'}`,
        )
      } else if (type === 'signup') {
        url = this.$router.resolve({
          name: 'Register',
          query: { redirect: window.location.href },
        })
        util.gaTrackEvent(
          'Presentation Share',
          `${inIframe ? 'iFrame > Sign Up' : 'Window > Sign Up'}`,
        )
      }

      if (url) {
        window.open(url.href, inIframe ? '_blank' : '_self')
      }
    },

    copyPresentationShare() {
      const inIframe = window.location !== window.parent.location
      if (this.copyStatus === 4) {
        util.gaTrackEvent(
          'Presentation Share',
          `${inIframe ? 'iFrame > Go to presentations' : 'Window > Go to presentations'}`,
        )
        window.open(`/presentation/${this.presentationCopyId}`, inIframe ? '_blank' : '_self')
        return
      }
      if (this.copyStatus > 1) {
        return
      }
      this.copyStatus = 2
      this.$http
        .post(config.api.copyPresentation, {
          id: this.$store.state.presentation.shareCode,
          name: this.$store.state.presentation.name,
        })
        .then((res) => {
          this.presentationCopyId = res.body.id
          setTimeout(() => {
            this.copyStatus = 3
            setTimeout(() => {
              this.copyStatus = 4
            }, 1000)
          }, 2000)
          util.gaTrackEvent(
            'Presentation Share',
            'Create new presentation',
            `from Presentation Share > ${inIframe ? 'iFrame' : 'Window'}`,
            this.$store.state.presentation.id,
            {
              ...mixpanelUtils.getPresentationContext(this.$store.state.presentation),
            },
          )
        }).catch((err) => {
          if (err.status === 400) {
            window.location.href = config.accountRemovalURL
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.share-presentation-bar {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  color: #000;
  font-size: 15px;
  padding: 8px 16px;
  font-weight: bold;

  .logged,
  .not-logged {
    width: 100%;
  }

  .btn {
    margin-left: 8px;
    font-weight: bold;
  }

  &.has-color {
    background-color: #000;
    color: #fff;
  }

  @media (max-width: 400px) {
    font-size: 13px;
    padding: 8px;

    .btn {
      font-size: 13px;
    }
  }
}
</style>
